import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App.jsx'
import './styles.css'

const container = document.getElementById('root')
const tree = (
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
)

let root = ReactDOM.createRoot(container)
root.render(tree)

// Self-heal a blank page. When an error escapes React's commit phase — most often a
// component's effect cleanup throwing while it unmounts on navigation — React tears the
// whole tree down, and no error boundary can catch it: the page just goes white until the
// user reloads by hand. If that leaves #root empty, re-mount once; reload only if even
// that fails. The guard keeps a persistent failure from turning into a reload loop.
const RELOAD_KEY = 'lugs_recovered_at'
window.addEventListener('error', () => {
  setTimeout(() => {
    if (container.children.length) return
    try {
      root = ReactDOM.createRoot(container)
      root.render(tree)
    } catch { /* fall through to the reload below */ }
    setTimeout(() => {
      if (container.children.length) return
      const last = Number(sessionStorage.getItem(RELOAD_KEY) || 0)
      if (Date.now() - last < 10000) return  // already tried — leave the watchdog message up
      sessionStorage.setItem(RELOAD_KEY, String(Date.now()))
      window.location.reload()
    }, 150)
  }, 0)
})
